import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Button from '@material-ui/core/Button';

@inject('foot')
@observer
class Foot extends Component {

    render() {
        const { year, datas } = this.props.foot;

        return (
            <div className="_foot">
                <div className="_f_logos">
                    Developed by
                    {
                        datas.list.map(item => {
                            return (
                                <Button title={item.title} key={item.id} component="a" variant="fab" className={"_foot_links "+item.title} href={item.url} target="_blank">
                                 &nbsp;
                                </Button>
                            )
                        })
                    }
                    <br/>
                    Copyright © 2015-{year} Justin Lee
                </div>
                
            </div>
        );
    }
}

export default Foot;
